import { Controller } from "stimulus";
import displayFlashMessage from "../../functions/displayFlashMessage";

export default class extends Controller {
  static values = { text: String };

  flash() {
    displayFlashMessage(this.textValue);
  }
}
